<template>
  <div class="centerPage">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
      <el-breadcrumb-item :to="{ path: '/doctor/info' }"><a href="javascript:void(0);" class="aHref">账号管理</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item>分享设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="formUserInfo">
      <div class="left">
        <h3 class="tit">预览效果</h3>
        <div ref="imageWrapper" class="imageDom" :class="n==1?'textRight':''" :style="{backgroundColor:previewBg}">
          <div class="logo">
            <img src="../../assets/img/logo.png" alt="">心理亦笙
          </div>
          <div class="doctorDel" :style="[{color:textColor}]">
            <div class="content">
              <h2>{{ user.fullName }} {{ user.enName }}</h2>
              <p class="eduBackground text">{{ user.eduBackground }}</p>
              <p class="company text">{{ user.company }}{{ user.department }}{{ user.job }}</p>
              <div class="text abodeCity">
                <p>所在地：<span>{{ user.abodeCity }}</span></p>
                <p>累计预约：<span>{{ user.consultationCount }} </span>人</p>
                <p>从业<span>{{ workYear }}</span>年</p>
              </div>
              <div class="line"></div>
              <div class="square"><span></span><span></span><span></span><span></span></div>
            </div>
            <p class="name">Neuropsych Studio</p>
            <img class="head-img" id="d-head-img" :src="user.headImgPath" alt="">
          </div>
          <div class="indication">{{ indicationList | indicationFmt }}</div>
          <div class="signature">
            <p v-if="user.signature" :style="{color:textColor}" class="motto" :title="user.signature">“{{
                user.signature
              }}”</p>
            <!--            <img src="../../assets/img/code.png" alt="" width="84">-->
            <div id="qrImg"></div>
            <div style="clear:both;"></div>
          </div>
        </div>
      </div>
      <div class="right">
        <h3 class="tit">上传分享照片</h3>
        <div class="submitTemp">
          <p class="selTit">模板选择：</p>
          <div class="flex tempList">
            <div class="type" v-for="(item,ind) in  tempList" :key="ind" @click="select(ind)">
              <img :src="item.img" alt="">
              <span class="selector" :class="{checked:ind==n}"></span>
            </div>
          </div>
          <p class="selTit">点击切换人像：</p>
          <el-upload
              class="avatar-uploader"
              name="uploadFile"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p class="selTit">背景颜色：</p>
          <el-color-picker v-model="previewBg" show-alpha></el-color-picker>
          <!--          <el-popover popper-class="popSketch"
                                placement="right"
                                trigger="click">
                      <div :style="{backgroundColor:color}" slot="reference" class="border"></div>
                      <div class="sketchPick">

          &lt;!&ndash;              <sketch-picker v-model="previewBg" @input="updateValue"></sketch-picker>&ndash;&gt;
                      </div>
                    </el-popover>-->
          <p class="selTit">文字颜色：</p>
          <el-color-picker v-model="textColor" show-alpha></el-color-picker>
          <!--          <el-popover popper-class="popSketch"
                                placement="right"
                                trigger="click">
                      <div :style="{backgroundColor:textColor}" slot="reference" class="border"></div>
                      <div class="sketchPick">
                        <sketch-picker v-model="textColor" @input="updateValueText"></sketch-picker>
                      </div>
                    </el-popover>-->
        </div>
        <el-button class="save" @click="generateImage">生成图片</el-button>
      </div>
    </div>
  </div>

</template>

<script>
// import {Sketch} from 'vue-color'
import base from "@/api/common";
import QRCode from 'qrcodejs2'
import html2canvas from "html2canvas"

export default {
  name: "shareSet",
  /*components: {
    'sketch-picker': Sketch
  },*/
  data() {
    return {
      uploadImgUrl: base.headImgUploadUrl,
      user: {},
      workYear: 0,
      indicationList: [],
      tempList: [
        {img: require("../../assets/img/templa_b.png")},
        {img: require("../../assets/img/templa_a.png")}
      ],
      n: 0,
      // color: 'rgba(0, 0, 0,1)',
      previewBg: 'rgba(255, 255, 255,1)',
      /*colors: {
        hex: '#194d33',
        hsl: {h: 150, s: 0.5, l: 0.2, a: 1},
        hsv: {h: 150, s: 0.66, v: 0.30, a: 1},
        rgba: {r: 25, g: 77, b: 51, a: 1},
        a: 1
      },*/
      textColor: 'rgba(11, 32, 48,1)',

      qrImgLoading: true,
      userAccount: '',
      websiteUrl: base.web_url,
    }
  },
  async mounted() {
    let that = this;
    let user = await base.utils.getCurrent();
    if (user != null) {
      that.is_login = true;
    }
    this.qrImgLoading = true;
    that.$ajax.post(base.api.doctor.consult.authorizeDetail.replace('{account}', user.account)).then((res) => {
      if (res.data.status === 'success') {
        that.user = res.data.data.detail;
        that.indicationList = res.data.data.indicationList;
        that.appointArr = res.data.data.appointArr;
        that.workYear = res.data.data.workYear || 0;
        if (that.user) {
          that.doctorId = res.data.data.detail.doctorId;
        }
        // 过多的列表会显示错乱: 限制6个
        that.indicationList = res.data.data.indicationList || [];
        if (that.indicationList.length > 6) {
          that.indicationList.splice(5, that.indicationList.length - 6)
        }
        // 二维码生成
        let qrCode = new QRCode('qrImg', {
          width: 100,
          height: 100,
          text: that.websiteUrl + '/' + that.user.account,
        });
        this.qrImgLoading = false;
      } else {
        that.$message.error(res.data.message);
      }
    });
  },
  filters: {
    indicationFmt(indications) {
      if (indications) {
        let skills = [];
        $(indications).each((i, o) => {
          if (o && o.cnName) {
            skills.push(o.cnName);
          }
        });
        return skills.join("、");
      }
    },
  },
  methods: {
    select(index) {
      this.n = index;
    },
    handleAvatarSuccess(res, file) {
      if (res.status === 'success') {
        this.user.headImgPath = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('图片上传失败.');
      }
    },
    /*updateValue(val) {
      this.color = val.hex8;
      this.previewBg = val.hex8
    },
    updateValueText(val) {
      this.textColor = val.hex8
    },*/
    generateImage() {
      if (this.qrImgLoading) {
        this.$message.warning('二维码信息加载中,请稍后');
        return;
      }
      let that = this;
      this.$ajax.get(that.user.headImgPath, {responseType: 'blob'}).then(res => {
        const blob = new Blob([res.data], {type: 'image/png'});
        let oFileReader = new FileReader();
        oFileReader.onloadend = function (e) {
          // 此处拿到的已经是 base64的图片了
          let base64 = e.target.result;
          that.user.headImgPath = base64;
          html2canvas(that.$refs.imageWrapper).then(canvas => {
            let imgUrl = canvas.toDataURL("image/png");
            if (imgUrl !== "") {
              if (window.navigator.msSaveOrOpenBlob) {
                let bstr = atob(imgUrl.split(',')[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
                }
                let blob = new Blob([u8arr]);
                window.navigator.msSaveOrOpenBlob(blob, 'chart-download' + '.' + 'png');
              } else {
                // 这里就按照chrome等新版浏览器来处理
                const a = document.createElement('a');
                a.href = imgUrl;
                a.setAttribute('download', that.user.account + '_share'); // 文件名
                a.click();
              }
            }
          });
        };
        oFileReader.readAsDataURL(blob);
      }).catch(err => {
        that.$message.error('error')
        console.error(err);
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/share.scss';

.doctorDel .name {
  font-size: 17px;
}

.indication {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doctorDel {
  position: relative;

  .content, p {
    z-index: 10
  }

  .head-img {
    z-index: 9;
    width: 80%;
    position: absolute;
    right: 0;
    bottom: 20px;
  }
}

.textRight {
  .head-img {
    left: 0
  }
}

</style>